var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.CustomScripts", function(busy, octopusRepository, $timeout) {
    return {
      title: "Custom deployment scripts",
      description: "Execute scripts during the deployment, without embedding them in your package",
      editTemplateUrl: "areas/projects/features/Octopus.Features.CustomScripts_edit.html",
      priority: 10,
      enable: function(action, step) {
      },
      disable: function(action, step) {
          Object.keys(action.Properties).filter(function(name) {
              return name.indexOf("Octopus.Action.CustomScripts.") === 0;
          }).forEach(function(name){
              delete action.Properties[name];
          });
      },
      preLink: function(scope) {
        var createScriptModel = function () {
          return { syntax: 'PowerShell', scriptBody: '' };
        };

        scope.scripts = {
          preDeploy: createScriptModel(),
          deploy: createScriptModel(),
          postDeploy: createScriptModel()
        };
      },
      editLink: function(scope, element) {
        // Maintains a mapping between simple properties of the
        // editor objects, and properties like action.Properties["Octopus.Action.CustomScripts.PreDeploy.ps1"]

        var syntaxExtensions = { PowerShell: 'ps1', CSharp: 'csx', Bash: 'sh', FSharp: 'fsx' };
        var extensionSyntaxes = _.invert(syntaxExtensions);
        var scriptToVar = { preDeploy: 'PreDeploy', deploy: 'Deploy', postDeploy: 'PostDeploy'};
        var varToScript = { PreDeploy: scope.scripts.preDeploy, Deploy: scope.scripts.deploy, PostDeploy: scope.scripts.postDeploy };
        var customScriptPrefix = "Octopus.Action.CustomScripts.";

        _.each(_.pairs(scope.action.Properties), function(prop){
          if (prop[0].indexOf(customScriptPrefix) === 0) {
            var scrext = prop[0].slice(customScriptPrefix.length).split('.');
            var script = varToScript[scrext[0]];
            script.syntax = extensionSyntaxes[scrext[1]];
            script.scriptBody = prop[1];
          }
        });

        _.each(['preDeploy', 'deploy', 'postDeploy'], function(editor){
          var varName = scriptToVar[editor];
          var script = varToScript[varName];

          scope.$watch('scripts.' + editor + '.syntax', function() {
            var pname = customScriptPrefix + varName + '.' + syntaxExtensions[script.syntax];
            _.each(syntaxExtensions, function(ext){
              var oldname = customScriptPrefix + varName + '.' + ext;
              if (ext !== syntaxExtensions[script.syntax] && scope.action.Properties.hasOwnProperty(oldname)) {
                delete scope.action.Properties[oldname];
              }
            });
            scope.action.Properties[pname] = script.scriptBody;
          });

          scope.$watch('scripts.' + editor + '.scriptBody', function() {
            var pname = customScriptPrefix + varName + '.' + syntaxExtensions[script.syntax];
            scope.action.Properties[pname] = script.scriptBody;
          });
        });
      }
    };
  });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.CustomScripts.js
// module id = 8071166827933813
// module chunks = 1